import { getCurrentInstance } from 'vue';

export function useToast() {
  const toast = getCurrentInstance()?.appContext.config.globalProperties.$toast;
  return {
    $toast: toast
  };
}